import { createStore } from 'vuex'

export default createStore({
  state: {
    asistencia : 'http://181.224.245.54',
    seguridad : 'http://181.224.245.54:84',
    menu : 'http://181.224.245.54:83',
    message : false,
    
   

  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
